<template>
  <div class="field-bd" :class="{'border': bottom}">
    <div class="ub">
      <div class="field-lable" :style="{width: labelWidth, 'text-align': labelAlign  }">
        <slot name="left">
          <span>{{label}}</span>
        </slot>
      </div>
      <div class="field-box ub-f1" :class="{'input-border': border}">
        <slot name="right">
          <input ref="input" :type="type" v-model='currentValue' @input="change()" :placeholder="placeholder">
        </slot>
        <a v-if='del' class="icon icon-delete" @click="clear()" v-show="currentValue" href="javascript:void(0)"></a>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
/**
   * @param value [String, Number] 表单v-model绑定的值
   * @param type [String] 表单类型,默认input，password,reset...
   * @param label [String] 表单栏目标题
   * @param labelWidth [String] 表单栏目标题宽度
   * @param labelAlign [String] 表单栏目标题文字对齐方式
   * @param bottom [Boolean] 是否显示底部边框
   * @param border [Boolean] 是否显示输入框边框默认不显示
   * @param del [Boolean] 输入框是否显示删除按钮
   * @param placeholder [String] 表单默认显示文字
   * @param change [Function] 表单输入变化时触发事件
   * @describe 可以和tSelect组件/tButton[size='small']配合使用
   *
   * @example
   *
     <t-field label-width='80px' label='商品类型：'>
        <t-select slot='right' :list="selectList" list-prop="name" v-model="select"></t-select>
      </t-field>
   */

export default {
  name: 'tField',
  props: {
    value: [String, Number],
    type: { type: String, default: 'input' },
    label: { type: String, default: '' },
    bottom: { type: Boolean, default: false },
    border: { type: Boolean, default: false },
    del: { type: Boolean, default: false },
    labelAlign: { type: String, default: 'left' },
    labelWidth: { type: String, default: 'auto' },
    placeholder: { type: String, default: '' },
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  watch: {
    value(val) {
      this.currentValue = val; // 新增value的watch，监听变更并同步到currentValue上,适用于外部操作的变更
    },
  },
  methods: {
    change: function () {
      this.$emit('change', this.currentValue);
      this.$emit('input', this.currentValue);
    },
    setFocus() {
      this.$refs.input.focus();
    },
    clear() {
      this.currentValue = '';
      this.$emit('input', this.currentValue);
      this.setFocus();
    },
  },
};

</script>
<style lang="scss">
@import "../style/mixin";
.field-bd {
  ::-webkit-input-placeholder {
    color: #B0B1AC;
    font-weight: normal;
  }
  padding: 4px;
  &.border {
    @include border-1px-b(#dedede)
  }
  .field-lable {
    color: #4D4D4D;
    font-size: 16px;
    line-height: 36px;
    height: 36px;
  }
  .field-box {
    position: relative;
    &.input-border {
      border: 1px solid rgba(0, 0, 0, 0.12);
      border-radius: 2px;
    }
    input {
      margin: 6px 0;
      padding: 0 8px;
      border: none;
      outline: none;
      display: block;
      width: 100%;
      color: #4D4D4D;
      line-height: 22px;
      height: 22px;
      font-size: 15px;
    }
    a {
      position: absolute;
      top: 0;
      right: 0;
      padding: 0 6px;
      line-height: 34px;
      color: #B2B2B2;
      font-size: 16px;
      z-index: 2;
    }
  }
  // 兼容button[size="small"]插槽
  .button-bd{
    margin-left: 0.1rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/field.vue